import { SyntheticEvent } from "react";
import { isSSR } from "../ssr";

export interface PageTrackingParams {
  pageCategory1: string | undefined;
  pageCategory2: string | undefined;
  pageType: string | undefined;
}

export const dispatchTrackingEvent = (
  eventName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  detail?: any,
  domEvent?: SyntheticEvent
): void => {
  if (!isSSR()) {
    const trackingEvent = new CustomEvent(eventName, {
      bubbles: true,
      cancelable: true,
      detail: detail
    });

    const dispatchingElement =
      domEvent && domEvent.target ? domEvent.target : document;

    dispatchingElement.dispatchEvent(trackingEvent);
  }
};
